import { GatsbyImage } from 'gatsby-plugin-image';
import propType from 'prop-types';
import React from 'react';

export default function AuthorInfo({ author }) {
  const { firstName, lastName, user, description, localImage } = author;
  return (
    <div className="author">
      <div className="author__avatar">
        <GatsbyImage
          image={localImage?.childImageSharp?.gatsbyImageData}
          alt={`${firstName}'s avatar`}
        />
      </div>
      <div className="author__info">
        <p className="author__info__name">
          {firstName} {lastName}
        </p>
        <p className="author__info__occupation">{user?.occupation}</p>
        <p className="author__info__bio">{description}</p>
      </div>
    </div>
  );
}

AuthorInfo.defaultProps = {
  author: {
    localImage: {
      childImageSharp: {
        gatsbyImageData: {}
      }
    },
    user: {
      occupation: ''
    },
    description: ''
  }
};

AuthorInfo.propTypes = {
  author: propType.shape({
    localImage: propType.shape({
      childImageSharp: propType.shape({
        gatsbyImageData: propType.shape({})
      })
    }),
    firstName: propType.string.isRequired,
    lastName: propType.string.isRequired,
    user: propType.shape({
      occupation: propType.string
    }),
    description: propType.string
  })
};
